import React from 'react';
import StatePage from '../StatePage/StatePage';

interface State {
  hasError: boolean;
}

interface Props {
  children: React.ReactNode;
}

class ErrorBoundary extends React.Component<Props, State> {
  state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <StatePage icon="alert" eyebrow="Error del sitio" title="Algo salió mal" text="No pudimos mostrar esta página. Vuelve al inicio e inténtalo nuevamente." actionLabel="Volver al inicio" tone="error" actionOnClick={() => this.setState({ hasError: false })} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
